<div class="modal fade"
     [class.show]="isOpenAccept"
     [style.display]="isOpenAccept ? 'block' : 'none'">

  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button type="button" class="close" (click)="close(false)">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <ng-content></ng-content>
      </div>

      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="close(false)">{{ 'MODAL.DENY' | translate}}</button>
        <button class="btn btn-primary" (click)="close(true)">{{ 'MODAL.ACCEPT' | translate }}</button>
      </div>

    </div>
  </div>
</div>
